import { styled } from '@uhg-abyss/web/tools/styled';
import { Box } from '@uhg-abyss/web/ui/Box';
import { Flex } from '@uhg-abyss/web/ui/Flex';
import { Heading } from '@uhg-abyss/web/ui/Heading';
import { Pagination } from '@uhg-abyss/web/ui/Pagination';
import { Text } from '@uhg-abyss/web/ui/Text';

import { PSXIcon } from '../../../PSXIcon';

export const Container = styled('div', {
  borderBottom: '1px solid $cardBorder',
  borderLeft: 'none',
  borderRight: 'none',
  marginBottom: '$sm',

  '@media (max-width: 744px)': {
    marginBottom: '0px',
    boxSizing: 'border-box',
  },
});

export const StyledIconContainer = styled('div', {
  '@media (max-width: 464px)': {
    marginBottom: '12px',
  },
});
export const StyledIcon = styled(PSXIcon, {
  height: '28px !important',
});

export const ContentContainer = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '12px',
  '@media (max-width: 744px)': {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    width: '100%',
    height: 'auto',
    background: 'white',
    flex: 'none',
    order: '3',
    flexGrow: '0',
  },
});

export const RatingSectionContainerStyles = {
  width: '100%',
};

export const verbatimContainerStyles = {
  'abyss-flex-root': {
    flexWrap: 'nowrap',
    overflowX: 'auto',
  },
};

export const modalStyles = {
  'abyss-modal-base-content-container': {
    width: '820px',
  },
  'abyss-modal-header-container': {
    display: 'none',
    border: '0',
    clip: 'rect(0 0 0 0)',
    height: '1px',
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    userSelect: 'none',
    width: '1px',
  },
};

export const sortButtonMobileStyles = {
  'abyss-button-root': {
    borderWidth: '2px',
    padding: '$sm $lg $sm $md',
    '.abyss-icon-symbol': {
      '@media (max-width: 464px)': {
        marginTop: '-4px',
        marginBottom: '-4px',
        marginRight: '4px',
      },
    },
    div: {
      margin: 0,
    },
  },
};
export const verbatimHeader = {
  marginTop: '12px',
  '@media (max-width: 744px)': {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    alignSelf: 'stretch',
  },
  '@media (min-width: 745px)': {
    display: 'inline-flex',
    justifyContent: 'start',
    alignItems: 'baseline',
    alignSelf: 'stretch',
    gap: '16px',
  },
};

export const RatingSectionHeader = styled(Text, {
  '&.abyss-text-root': {
    fontStyle: 'normal',
    fontWeight: 'bold',
    lineHeight: '16px',
    marginBottom: '3.33px',
    '@media (max-width: 744px)': {
      fontSize: '12.64px',
      marginBottom: '3.33px',
      lineHeight: '16px',
    },
  },
});

export const RatingOverviewSection = styled(Flex, {
  marginBottom: '24px',
  width: '100%',
});
export const RatingReviewsPercentageSection = styled(Flex, {
  marginBottom: '20px',
  paddingRight: '10px',
  width: '100%',
});

export const ProviderRatingNumber = styled('p', {
  color: '$core.color.brand.100',
  fontFamily: '$heading',
  fontSize: '28.83px',
  lineHeight: '36px',
  marginBottom: 0,
});

export const OverallRatingContainer = {
  '&.abyss-flex-root': {
    '@media (max-width: 464px)': {
      marginBottom: '$xs',
    },
  },
};

export const numberOfReviewsTextStyles = (
  mobileScreen: boolean,
  isGEHAV2: boolean
) => ({
  '&.abyss-text-root': {
    color: isGEHAV2 ? '$core.color.brand.100' : '',
    marginLeft: '4px',
    marginTop: '12px',
    marginBottom: '6px',
    fontSize: '14.22px',
    ...(mobileScreen && {
      fontSize: '12.64px',
    }),
  },
});

export const RatingDescriptionWithStarsStyles = {
  gap: '$sm',
  marginRight: '$sm',
  '@media (max-width: 744px)': {
    flexDirection: 'column',
  },
};

export const verbatimCard = (mobileScreen: boolean) => ({
  minWidth: '282px',
  maxWidth: '282px',
  minHeight: '132px',
  paddingTop: '16px',
  paddingBottom: '16px',
  paddingLeft: '24px',
  paddingRight: '24px',
  borderRadius: '8px',
  cursor: 'pointer',
  overflow: 'hidden',
  '&:hover': {
    border: '2px solid $core.color.brand.80',
  },
  '&:focus-within': {
    border: '2px solid $core.color.brand.80',
  },
  '&.abyss-card-root': {
    marginTop: '$md',
    marginRight: '18px',
    ...(mobileScreen && {
      marginTop: '11px',
      height: '112px',
      lineHeight: '16px',
      maxWidth: '100%',
    }),
  },
});

export const SuggestionBox = styled(Box, {
  width: '340px',
  minHeight: '176px',
  padding: '16px 24px',
  borderRadius: '8px',
  border: '1px solid $core.color.neutral.20',
});

export const UnOrderList = styled('ul', {
  listStyle: 'disc',
  marginLeft: '16px',
  li: {
    marginBottom: '7px',
  },
});

export const SuggestionHeading = styled(Heading, {
  '&.abyss-heading-root': {
    dynamic: ({ cssProps: { isGEHAV2 } = {} }) => ({
      color: isGEHAV2
        ? '#$core.color.brand.100 !important'
        : '$core.color.neutral.90 !important',
    }),
    fontWeight: 700,
    fontSize: '$sm',
    lineHeight: '18px',
  },
});

export const SuggestionWrapper = styled(Flex, {
  gap: '48px',
  '@media (max-width: 744px)': {
    gap: '12px',
  },
});

export const SuggestioContent = styled(Text, {
  '&.abyss-text-root': {
    fontWeight: 600,
  },
});

export const SuggestioContentModal = styled(Text, {
  '&.abyss-text-root': {
    fontWeight: 400,
    dynamic: ({ cssProps: { isGEHAV2 } = {} }) => ({
      color: isGEHAV2 ? '$core.color.brand.100' : '',
    }),
  },
});

export const ViewMoreButton = styled('button', {
  marginTop: '8px',
  gap: '4px',
  display: 'flex',
  alignItems: 'center',
});
export const verbatimTextStyles = (
  mobileScreen: boolean,
  isGEHAV2: boolean
) => ({
  '&.abyss-text-root': {
    color: isGEHAV2 ? '$core.color.brand.100' : '$core.color.neutral.90',
    fontSize: '$md',
    lineHeight: '$core-lineHeight-md',
    fontweight: 'normal',
    ...(mobileScreen && {
      fontSize: '12.64px',
    }),
  },
});

export const DateTextStyles = {
  '&.abyss-text-root': {
    fontSize: '12.64px',
    color: '$core.color.brand.100',
    fontWeight: '500',
    lineHeight: '16px',
  },
};

export const viewAllVerbatimFlexStyles = {
  '&.abyss-flex-root': {
    marginBottom: '$lg',
    '@media (max-width: 744px)': {
      justifyContent: 'center',
      flexDirection: 'column',
    },
  },
  '&.abyss-flex-content-root': {
    alignItems: 'center',
  },
};

export const AllPatientReviewsContainer = styled('div', {
  maxWidth: '1200px',
  marginLeft: 'auto',
  marginRight: 'auto',
  padding: '$lg 0',
  '@media (max-width: 1248px)': {
    marginLeft: '24px',
    marginRight: '24px',
  },
  '@media (max-width: 744px)': {
    marginLeft: '16px',
    marginRight: '16px',
    padding: '16px 0',
  },
});

export const SectionContainer = styled('div', {});

export const showingVerbatimCountTextStyles = {
  'abyss-text-root': {
    fontSize: '$sm',
    color: '$core.color.neutral.80',
    fontWeight: '600',
  },
};

export const showingResultsCountTextStyles = {
  'abyss-text-root': {
    fontSize: '$sm',
    color: '$core.color.neutral.80',
    lineHeight: '18px',
    fontWeight: '600',
  },
};

export const ContainerSubHeading = styled('div', {
  '@media (max-width: 464px)': {
    display: 'flex',
    width: '176px',
  },
  '@media (min-width: 745px)': {
    display: 'flex',
    width: 'auto',
  },
});

export const TextHeadingPatientReviews = styled(Text, {
  '&.abyss-text-root': {
    color: '$core.color.brand.100',
    fontStyle: 'normal',
    fontWeight: '700',
    '@media (max-width: 744px)': {
      fontSize: '20.25px',
      lineHeight: '24px',
    },
    '@media (min-width: 745px)': {
      fontSize: '25.63px',
      lineHeight: '32px',
    },
  },
});

export const TextSubHeadingWhatPatientsAreSaying = styled(Text, {
  '&.abyss-text-root': {
    '@media (max-width: 744px)': {
      color: '#000',
      fontStyle: 'normal',
      fontWeight: '700',
      lineHeight: '20px',
      fontSize: '16px',
    },
    '@media (min-width: 745px)': {
      color: '$core.color.brand.100',
      fontStyle: 'normal',
      fontWeight: '700',
      lineHeight: '24px',
      fontSize: '20.25px',
    },
  },
});

export const PaginationComponentStyled = styled(Pagination, {
  '&.abyss-pagination-root': {
    justifyContent: 'space-between',
    '@media (max-width: 744px)': {
      width: '100%',
      marginBottom: '32px',
    },
    '@media (min-width: 745px)': {
      width: 'fit-content',
    },
  },
});
